/* eslint-disable @typescript-eslint/no-explicit-any */
import { ActionTree } from "vuex";
import { RootState } from "../types";
import { TemplatesInt } from "./types";

export const actions: ActionTree<TemplatesInt, RootState> = {};
